import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { isRequired, isPositiveNumber, isInteger, isGreaterThanField } from '../../../../utils/services/validator';
import { toNumberIfNotEmptyString, toDecimalNoRound } from '../../../../utils/services/normalizer';
import { Input, Checkbox } from '../../../../core/components';
import { WasteTypeSelect, ContainerSizeSelect, RecurringFrequencySelect } from '../../../../common/components';
import { currency } from '../../../../utils/services/formatter';

const isValidPrice = isGreaterThanField('service.Cart.price.pickupExpectedCost', currency);

const CartService = ({
  serviceType,
  wasteTypes,
  containerSizes,
  recurringFrequencies,
  hasRecognitionProgram,
  hasIncumbentRebateProgram,
  initialValues,
  change,
}) => {
  const [showIncumbentRebateMonthly, setShowIncumbentRebateMonthly] = useState(false);
  const [showAdjustedPrice, setShowAdjustedPrice] = useState(true);

  useEffect(() => {
    if (
      initialValues &&
      initialValues.service &&
      initialValues.service.Cart &&
      initialValues.service.Cart.incumbentRebateProgram
    ) {
      setShowIncumbentRebateMonthly(true);
    }
  }, []);

  useEffect(() => {
    if (initialValues && initialValues.service && initialValues.service.Cart) {
      setShowIncumbentRebateMonthly(Boolean(initialValues.service.Cart.incumbentRebateProgram));
      if (initialValues.service.Cart.id) {
        setShowAdjustedPrice(true);
      }
    }
  }, [initialValues]);

  const hideAdjustedPrice = () => {
    if (showAdjustedPrice) {
      setShowAdjustedPrice(false);
      change('service.Cart.price.pickup', null);
    }
  };
  const onChangeRebateProgram = () => {
    setShowIncumbentRebateMonthly(!showIncumbentRebateMonthly);
    hideAdjustedPrice();
  };

  return (
    <>
      {hasRecognitionProgram && (
        <Field
          name="service.Cart.recognizedProgram"
          component={Checkbox}
          label="Recognized Program"
          block
          margin="small no"
        />
      )}
      {hasIncumbentRebateProgram && (
        <Field
          name="service.Cart.incumbentRebateProgram"
          component={Checkbox}
          label="Rebate Program"
          block
          margin="small no"
          onChange={onChangeRebateProgram}
        />
      )}
      {hasIncumbentRebateProgram && showIncumbentRebateMonthly && (
        <Field
          name="service.Cart.incumbentRebateMonthly"
          component={Input}
          label="Incumbent price"
          type="number"
          normalize={toNumberIfNotEmptyString}
          validate={[isPositiveNumber, isInteger]}
          min={0}
        />
      )}
      <Field
        name="service.Cart.numberOfContainers"
        component={Input}
        label="Number of containers"
        type="number"
        normalize={toNumberIfNotEmptyString}
        validate={[isRequired, isPositiveNumber, isInteger]}
        min={0}
      />

      <Field
        name="service.Cart.wasteType"
        component={WasteTypeSelect}
        serviceType={serviceType}
        acceptedWasteTypes={wasteTypes}
        validate={isRequired}
      />

      <Field
        name="service.Cart.containerSize"
        component={ContainerSizeSelect}
        serviceType={serviceType}
        acceptedContainerSizes={containerSizes}
        validate={isRequired}
      />
      {initialValues.service.Cart && initialValues.service.Cart.price && showAdjustedPrice && (
        <Field
          name="service.Cart.price.pickup"
          label="Adjusted Pickup Price"
          component={Input}
          type="number"
          normalize={toDecimalNoRound}
          validate={[isValidPrice]}
        />
      )}
      <Field
        name="service.Cart.recurringFrequency"
        component={RecurringFrequencySelect}
        serviceType={serviceType}
        acceptedRecurringFrequencies={recurringFrequencies}
        validate={isRequired}
      />
      <Field name="service.Cart.note" component={Input} label="Notes" type="text" />
    </>
  );
};

CartService.propTypes = {
  serviceType: PropTypes.string,
  wasteTypes: PropTypes.array,
  containerSizes: PropTypes.array,
  recurringFrequencies: PropTypes.array,
  hasIncumbentRebateProgram: PropTypes.bool,
  hasRecognitionProgram: PropTypes.bool,
  initialValues: PropTypes.object,
  change: PropTypes.func.isRequired,
};

CartService.defaultProps = {
  serviceType: undefined,
  wasteTypes: undefined,
  containerSizes: undefined,
  recurringFrequencies: undefined,
  hasIncumbentRebateProgram: undefined,
  hasRecognitionProgram: undefined,
  initialValues: undefined,
};

export default CartService;
